<template>
	<div
		class="help-composer"
		data-testid="help-assistant-composer"
	>
		<v-textarea
			:id="inputId"
			v-model="text"
			label="Ask a question"
			data-testid="help-assistant-input"
			class="help-composer__input"
			rows="2"
			auto-grow
			hide-details
			outlined
			dense
			:maxlength="MAX_MESSAGE_CHARS"
			:disabled="disabled || streaming"
			placeholder="Ask about brands, channels, statements, or languages…"
			@keydown="handleKeydown"
		/>
		<v-btn
			v-if="streaming"
			data-testid="help-assistant-stop-button"
			aria-label="Stop generating"
			outlined
			class="help-composer__button"
			@click="handleStop"
		>
			<LucideIcon
				name="Square"
				:size="14"
				class="help-composer__stop-icon"
			/>
			Stop
		</v-btn>
		<v-btn
			v-else
			data-testid="help-assistant-send-button"
			color="primary"
			class="help-composer__button"
			:disabled="isSendDisabled"
			@click="handleSend"
		>
			Send
		</v-btn>
	</div>
</template>

<script>
import { LucideIcon } from '@syrenis/cassie-material-design'
import { MAX_MESSAGE_CHARS } from './utils/chat-core.js'

export default {
	name: 'help-composer',
	components: {
		LucideIcon
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		streaming: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			text: '',
			inputId: `help-assistant-input-${this._uid}`,
			MAX_MESSAGE_CHARS
		}
	},
	computed: {
		isSendDisabled () {
			return this.text.trim().length === 0 || this.disabled
		}
	},
	methods: {
		handleKeydown (event) {
			if (event.key === 'Enter' && !event.shiftKey) {
				event.preventDefault()
				this.handleSend()
			}
		},
		handleSend () {
			const trimmed = this.text.trim()
			if (!trimmed || this.disabled || this.streaming) return
			this.$emit('send', { text: trimmed })
			this.text = ''
		},
		handleStop () {
			this.$emit('stop')
		}
	}
}
</script>

<style lang="scss" scoped>
.help-composer {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid var(--border, #E0E2E5);

  &__input {
    flex: 1 1 auto;
    font-size: 0.875rem;
  }

  &__button {
    flex: 0 0 auto;
    min-height: 24px;
    min-width: 24px;
  }

  &__stop-icon {
    margin-right: 6px;
  }
}
</style>
